import React, { useEffect, useRef, useState } from "react";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import NiceModal from "@ebay/nice-modal-react";

DataTable.use(DT);

const ResponsesTable = ({ responses = [], onUpdated = () => {} }) => {
  const tableRef = useRef(null);
  const [localResponses, setLocalResponses] = useState(responses);

  useEffect(() => {
    if (responses) {
      setLocalResponses(responses);
    }
  }, [responses]);

  window.view = (public_id) => {
    console.log("!!! response VIEW: ", public_id);
    NiceModal.show("chat-session", { agent: null, chat_session_id: public_id });
  };

  const tableData = localResponses.map((response) => {
    return [
      response.public_id,
      response.email,
      response.user_name,
      response.field_title,
      response.response,
      response.updated_at ? new Date(response.updated_at) : "",
    ];
  });

  return (
    <div>
      <div style={{ fontSize: "32px", fontWeight: "bold" }}>
        Responses ({responses.length})
      </div>
      <DataTable
        ref={tableRef}
        data={tableData}
        className="display"
        options={{
          responsive: true,
          select: true,
          pageLength: 25,
          order: [[5, "desc"]],
        }}
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>Email</th>
            <th>User</th>
            <th>Type</th>
            <th style={{ width: "55%" }}>Response</th>
            <th style={{ minWidth: "200px" }}>Updated At</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  );
};

export default ResponsesTable;
